import { render, staticRenderFns } from "./GetBenefits.vue?vue&type=template&id=3cdd25c1"
import script from "./GetBenefits.vue?vue&type=script&lang=js"
export * from "./GetBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports